export enum SelectionMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
